<!-- couponCard -->
<template>
  <div :class="[
    'couponCard',
    {
      invalidCoupon: !valid && couponStatus !== 'notStart',
      active: couponInfo.active,
    },
  ]" @click="couponSelect">
    <div class="couponInfo">
      <p class="couponName">
        <i v-if="couponInfo.frontEndName && couponInfo.frontEndName.substr(0, 1) == '【'"
          class="title-special-processing" />
        <i v-else-if="couponInfo.couponName && couponInfo.couponName.substr(0, 1) == '【'"
          class="title-special-processing" />
        {{ couponInfo.frontEndName || couponInfo.couponName }}
      </p>
      <p class="couponArea">{{ showType(couponInfo.productionFitType) }}</p>
      <p class="couponExpired">{{ couponInfo.dateTimeInfo }}</p>
      <!-- 产品详情页领取状态 -->
    </div>
    <div class="couponDiscount">
      <p v-if="couponInfo.tagName" class="couponTag">{{ couponInfo.tagName }}</p>
      <p v-if="couponInfo.discountType === couponTypeOff" class="couponOff">
        <span class="copuonCurrency">￥</span>
        <span class="couponValue">{{ couponInfo.discountAmount }}</span>
      </p>
      <p v-else class="couponSale">
        <span class="couponValue">{{ couponInfo.discountAmount }}</span>
        <span class="couponSale">折</span>
      </p>
      <p class="couponLimit">满{{ couponInfo.usableCondition }}可用</p>
      <slot></slot>
    </div>

    <i v-if="valid" v-show="couponInfo.active" class="selectedIcon"></i>
    <!-- 适用用户标签 -->
    <span class="fitUser" v-if="couponInfo.fitUser !== 1">{{
      couponInfo.fitUser === 2 ? '新用户专享' : '老用户专享'
    }}</span>
  </div>
</template>

<script>
import { COUPONTYPE_OFF } from '@/assets/js/couponConfig';

export default {
  props: {
    couponInfo: {
      type: Object,
      default: () => ({}),
    },
    orderType: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    couponStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      couponTypeOff: COUPONTYPE_OFF,
    };
  },
  methods: {
     showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
    couponGet() {
      if (!this.coupon.canBeGot) return;
      this.$emit('couponGet', this.couponInfo);
    },
    couponSelect() {
      if (!this.valid) return;
      this.$emit('couponSelect', this.couponInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../index.scss';

.couponCard {
  position: relative;
  display: flex !important;
  margin: auto;
  cursor: pointer;
  @include background(536px, 178px);
  @include backgroundImage('member_coupon.png');

  .couponDiscount {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 185px;
    height: 100%;

    .couponTag {
      position: absolute;
      top: 2px;
      left: 2px;
      height: 33px;
      padding: 0 7px;
      color: #ff6c02;
      font-size: 18px;
      line-height: 33px;
      background: #fff0e6;
      border-radius: 7px 0 14px 0;
    }

    .couponOff,
    .couponSale {
      box-sizing: content-box;
      height: 49px;
      color: rgba(255, 83, 20, 1);
      font-size: 43px;
      line-height: 51px;
      text-align: center;

      .copuonCurrency,
      .couponSale {
        margin: 0 4px;
        font-weight: bold;
        font-size: 25px;
      }

      .couponValue {
        color: rgba(255, 83, 20, 1);
        font-weight: bold;
        font-size: 43px;
      }
    }

    .couponLimit {
      height: 25px;
      margin-top: 4px;
      color: rgba(255, 83, 20, 1);
      font-size: 18px;
      line-height: 25px;
      text-align: center;
    }
  }

  .couponInfo {
    position: relative;
    flex: 1;
    padding: 29px 0 29px 29px;

    .couponName {
      max-width: 281px;
      height: 36px;
      margin-bottom: 18px;
      overflow: hidden;
      color: rgba(96, 55, 28, 1);
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .couponArea,
    .couponExpired {
      height: 29px;
      // margin-right: 150px;
      margin-bottom: 4px;
      color: rgba(96, 55, 28, .5);
      font-weight: 400;
      font-size: 22px;
      // font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      line-height: 29px;
    }

    .couponGet {
      position: absolute;
      right: 20px;
      bottom: 25px;
      box-sizing: content-box;
      height: 36px;
      padding: 11px 22px;
      color: #ff6c02;
      font-weight: 400;
      font-size: 25px;
      background: rgba(255, 108, 2, 0.1);
      border-radius: 29px;
      cursor: pointer;

      &.couponCanBeGot {
        color: #fff;
        background: #ff6c02;
      }
    }
  }

  .fitUser {
    position: absolute;
    top: 1px;
    left: 2px;
    display: block;
    padding: 4px 5px;
    color: #ff6c02;
    font-size: 18px;
    background: #fff0e6;
    border-radius: 5px 0 7px 0;
  }

  .optimalCoupon {
    position: absolute;
    top: 2px;
    right: 2px;
    display: block;
    padding: 4px 5px;
    color: #fff;
    font-size: 18px;
    background: #ff6c02;
    border-radius: 0 5px 0 5px;
  }

  .selectedIcon {
    position: absolute;
    right: 0;
    bottom: 0;
    display: block;
    width: 34px;
    height: 34px;
    background: url('../../../../../assets/img/components/coupon/coupon_selected.png') no-repeat center;
    background-size: contain;
  }

  &.invalidCoupon {
    background-image: url('../../../../../assets/img/components/coupon/coupon_cantuse.png');

    .couponDiscount {

      .couponOff,
      .couponSale {
        color: #a5a5a5;
      }

      .couponTag {
        opacity: 0.5;
      }
    }

    .couponInfo {

      .couponName,
      .couponArea,
      .couponExpired {
        opacity: 0.5;
      }
    }
  }

  &.active {
    background-image: url('../../../../../assets/img/components/coupon/coupon_active.png');
  }
}
</style>
